import { Component, Vue } from 'vue-property-decorator';
import { NotificationType } from '@/core/interfaces/notificationType';
import { VehicleType } from '@/core/interfaces/vehicleType';
import { Notification } from '@/core/interfaces/notification';
import i18n from '@/i18n';

@Component
export default class UsesNotificationMessage extends Vue {
    public get notificationMessage(): string {
        // @ts-ignore
        if (!this.notificationType || !this.vehicleType) {
            return '-';
        }

        // @ts-ignore
        return i18n.t(`${this.vehicleType.name}.notification-types.${this.notificationType.code}`, this.notification?.meta || []).toString() || '-';
    }

    translateNotificationMessage(notificationType: NotificationType, vehicleType?: VehicleType, notification?: Notification): string {
        const vt = vehicleType || this.$store.getters.vehicleTypeById(notificationType.vehicle_type_id);

        return i18n.t(`${vt.name}.notification-types.${notificationType.code}`, notification?.meta || []).toString() || '-';
    }
}
